export const parseFormToBackend = ({ form, tags, isWedding }) => {
  const { dateAndPeople, messageAndCatering, userInfo } = form;
  const autocomplete = tags.find(tag => tag.value === dateAndPeople.eventType)?.label;

  const requireCatering = messageAndCatering.catering.requireCatering;

  const hasBothTimes = dateAndPeople.timeFrom && dateAndPeople.timeTo;

  let timeFrom = null;
  let timeTo = null;
  if (hasBothTimes) {
    timeFrom = dateAndPeople.timeFrom;
    timeTo = dateAndPeople.timeTo;
  }

  return {
    room_tag_autocomplete: autocomplete, // This is label of the option
    room_tag: dateAndPeople.eventType, // This is value of the option
    date: dateAndPeople.date,
    enquiry_date: dateAndPeople.date,
    people: dateAndPeople.people,
    layout: dateAndPeople.layout,
    time_from: timeFrom,
    time_to: timeTo,
    enquiry_time_from: timeFrom,
    enquiry_time_to: timeTo,
    enquiry_flexible_on_time: isWedding || dateAndPeople.flexibleOnTime,

    enquiry_comment: !isWedding ? messageAndCatering.message : `Wedding brochure request.\n\n${messageAndCatering.message}`,
    require_catering: requireCatering,
    own_catering: messageAndCatering.catering.ownCatering,
    enquiry_catering_options_breakfast: requireCatering && messageAndCatering.catering.breakfast,
    enquiry_catering_options_tea_and_coffee: requireCatering && messageAndCatering.catering.teaAndCoffee,
    enquiry_catering_options_lunch: requireCatering && messageAndCatering.catering.lunch,
    enquiry_catering_options_dinner: requireCatering && messageAndCatering.catering.dinner,
    enquiry_catering_options_drinks_reception: requireCatering && (messageAndCatering.catering.drinksReception || messageAndCatering.extendedCatering.drinksReception),
    enquiry_catering_options_other: requireCatering && messageAndCatering.catering.other,

    enquiry_catering_options_seated_meal: requireCatering && messageAndCatering.extendedCatering.seatedMeal,
    enquiry_catering_options_buffet: requireCatering && messageAndCatering.extendedCatering.buffet,
    enquiry_catering_options_canapes: requireCatering && messageAndCatering.extendedCatering.canapes,
    enquiry_catering_options_open_bar: requireCatering && messageAndCatering.extendedCatering.openBar,

    enquiry_fullname: userInfo.fullName,
    enquiry_email: userInfo.email,
    enquiry_phone: userInfo.phone,
    marketing_consent: userInfo.marketingConsent ?? false,
  };
};

export const parseFormFromBackend = (data) => {
  return {
    dateAndPeople: {
      eventType: data.room_tag ?? '',
      date: data.date ?? '',
      people: data.people ?? '',
      timeFrom: data.time_from ?? null,
      timeTo: data.time_to ?? null,
      flexibleOnTime: data.enquiry_flexible_on_time ?? false,
      layout: data.layout ?? null,
    },

    messageAndCatering: {
      message: data.enquiry_comment ?? '',
      catering: {
        requireCatering: data.require_catering ?? false,
        ownCatering: data.own_catering ?? false,
        breakfast: data.enquiry_catering_options_breakfast ?? false,
        teaAndCoffee: data.enquiry_catering_options_tea_and_coffee ?? false,
        lunch: data.enquiry_catering_options_lunch ?? false,
        dinner: data.enquiry_catering_options_dinner ?? false,
        drinksReception: data.enquiry_catering_options_drinks_reception ?? false,
        other: data.enquiry_catering_options_other ?? false,
      },
      extendedCatering: {
        seatedMeal: data.enquiry_catering_options_seated_meal ?? false,
        buffet: data.enquiry_catering_options_buffet ?? false,
        canapes: data.enquiry_catering_options_canapes ?? false,
        drinksReception: data.enquiry_catering_options_drinks_reception ?? false,
        openBar: data.enquiry_catering_options_open_bar ?? false,
      },
    },

    userInfo: {
      fullName: data.enquiry_fullname ?? '',
      email: data.enquiry_email ?? '',
      phone: data.enquiry_phone ?? '',
    },
  };
};
